<template>
  <b-modal @show="disableButton()" id="join-class-modal" hide-footer title="Vào dạy" centered no-close-on-backdrop >
    <div v-if="!loading">
      <p>Sau khi kết thúc ca học, cần check-in hoàn thành tác vụ.</p>
      <p>Trường hợp học viên vào muộn quá 15 phút, tiến hành check-in hủy ca học.</p>
      <button type="button" class="btn btn-primary" :disabled="isDisableZoom" @click="openZoom">Vào zoom</button>
      <p class="mt-4">Học viên lỗi Zoom? <span  style="color: #0C9200; cursor: pointer" @click="openGoogleMeet">Đổi công cụ Google Meet tại đây.</span></p>
    </div>
    <div v-else class="d-flex justify-content-center align-items-center" style="height: 150px;">
      <i class="el-icon-loading"  style="font-size: 25px"></i>
    </div>

  </b-modal>
</template>
<script>
import {JOIN_CLASS} from "@/core/services/store/tutor/tutor.module";
import moment from "moment-timezone";

export default {
  name: "JoinClassModal",
  props: {
    task: {
      type: Object,
      default: () => ({})
    }
  },
  data(){
    return {
      loading:false,
      isDisableZoom: false
    }
  },
  methods:{
    async openZoom(){
      try {
        this.loading = true
        let payload = {
          id: this.task?.id,
          tool: 'zoom'
        }
        await this.$store.dispatch(JOIN_CLASS, payload)
        this.$emit('loadDetail')
        this.$bvModal.hide('join-class-modal')
        window.open(this.task?.link_test, "_blank")
      }catch (e) {

      }finally {
        this.loading = false
      }

    },
  async openGoogleMeet(){
      try {
        this.loading = true
        let payload = {
          id: this.task?.id,
          tool: 'meet'
        }
        await this.$store.dispatch(JOIN_CLASS, payload)
        this.$emit('loadDetail')
        this.$bvModal.hide('join-class-modal')
        window.open(this.task?.link_meet, "_blank")
      }catch (e) {

      }finally {
        this.loading = false
      }
   },
    disableButton(){
      this.loading = false

      const now = moment().add(10, 'minutes'); // giữ nguyên dạng moment object
      const startAt = moment(this.task?.start_date, 'YYYY-MM-DD HH:mm:ss'); // cũng là moment object
      this.isDisableZoom = now.isBefore(startAt);
    }
  }
}
</script>


<style scoped>

</style>